import CollectionCreateButton from './collection-create-button';

export default CollectionCreateButton;